import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_protected/dashboard/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <Navigate to="/dashboard/matchs" />;
}
